import { Layer, Source } from "react-map-gl/mapbox"

interface EarthquakeLayerProps {
  opacity?: number
}

export const EarthquakeLayer = ({ opacity = 0.7 }: EarthquakeLayerProps) => {
  return (
    <Source
      id="raster-earthquake"
      type="raster"
      tiles={[
        "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=risq_zonage_sismique&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
      ]}
      tileSize={256}
      maxzoom={15}
    >
      <Layer id="raster-earthquake" type="raster" source="raster-earthquake" paint={{ "raster-opacity": opacity }} />
    </Source>
  )
}
